import React from 'react'
import { useNavigate } from 'react-router-dom'
import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import WallboardPage from '../pages/wallboard/WallboardPage'
import WallboardManager from '../pages/wallboard/manage/WallboardManager'

// Logged-in wallboard display. The /wallboard path renders chrome-less via
// the wallboardMode check in MainFrame.jsx; /wallboard-settings keeps the
// normal app frame (deliberately a different prefix so the chrome-less check
// can't swallow the editor).
const WallboardSessionRoute = () => {
  const navigate = useNavigate()
  return <WallboardPage mode="session" onExit={() => navigate('/dashboard')} />
}

export default [
  {
    path: '/wallboard',
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="Wallboards"
        benefits={[
          'Live station displays for shifts, fleet and KPIs',
          'Multiple auto-rotating screens per display',
          'Team shoutouts on the big screen',
        ]}
      >
        <WallboardSessionRoute />
      </SubscriptionGate>
    ),
    title: 'Wallboard',
  },
  {
    path: '/wallboard-settings',
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="Wallboards"
        benefits={[
          'Live station displays for shifts, fleet and KPIs',
          'Multiple auto-rotating screens per display',
          'Team shoutouts on the big screen',
        ]}
      >
        <WallboardManager />
      </SubscriptionGate>
    ),
    title: 'Wallboard Settings',
  },
]
